import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { AuroraThemeType } from '../../utils/themes/ThemeProvider'

type Props = {
  size?: number | string
}

export const AuroraCoachingSpotIllustration: FunctionComponent<Props> = ({ size = 96 }) => {
  const { colors } = useTheme() as AuroraThemeType
  const { spotIllustration } = colors.icons

  return (
    <Svg width={size} height={size} viewBox='0 0 64 64' fill='none'>
      <Path
        d='M32.225 0.239258C27.8073 0.239258 23.5212 0.996819 19.4855 2.49044C9.87754 6.05186 3.12272 13.9474 0.952482 24.1524C-0.481698 30.806 -0.298315 36.9601 1.51654 42.9574C3.83349 50.6164 9.52089 57.0753 17.1205 60.6772C20.8932 62.4693 25.2273 63.4925 30.0003 63.7176C30.6137 63.7454 31.2372 63.7606 31.8569 63.7606C35.6865 63.7606 39.5388 63.2357 43.3076 62.2012C43.5972 62.1291 43.8729 62.0545 44.1638 61.9685C47.5507 60.9769 50.5987 59.4087 53.2065 57.3131C56.0382 55.0505 58.369 52.1822 60.127 48.7927C60.4735 48.125 60.8049 47.4218 61.1704 46.5808C63.1812 41.9114 64.1525 36.6844 63.9805 31.4586C63.8996 29.148 63.5556 26.6919 62.9612 24.1524C61.9823 20.032 60.3862 16.1569 58.345 12.9395C57.786 12.0757 57.2725 11.3497 56.7641 10.6971C53.0952 5.9646 47.3787 2.64347 40.2382 1.098C37.6151 0.528876 34.9188 0.240522 32.2262 0.240522L32.225 0.239258Z'
        fill='white'
        fillOpacity='0.4'
      />
      <Path
        d='M48.8754 41.3435C51.3186 35.8362 51.1547 27.7494 47.6201 22.7454C45.1668 19.2721 40.3518 16.5886 36.1388 16.1392C31.7393 15.6699 27.0544 16.0266 23.1918 18.272C19.7974 20.2446 16.9274 23.1872 15.3591 26.8157C14.3465 29.16 13.8934 31.7409 14.0211 34.2905C14.2764 39.3871 16.6383 44.6115 20.9752 47.3839C26.2133 50.7332 33.2976 52.1376 39.2428 49.956C42.9114 48.6105 47.1282 45.2799 48.8742 41.3435H48.8754Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M45.5089 32.4782C45.9795 38.5524 42.1357 44.8394 34.7973 45.9083C22.5976 47.6831 14.0439 35.138 22.8016 25.3389C30.304 16.9429 44.6202 21.0245 45.5089 32.4782Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M32.5165 42.0822C37.0415 42.0822 40.7097 38.414 40.7097 33.889C40.7097 29.364 37.0415 25.6958 32.5165 25.6958C27.9915 25.6958 24.3232 29.364 24.3232 33.889C24.3232 38.414 27.9915 42.0822 32.5165 42.0822Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M32.5156 37.2166C34.3537 37.2166 35.8437 35.7266 35.8437 33.8885C35.8437 32.0505 34.3537 30.5604 32.5156 30.5604C30.6775 30.5604 29.1875 32.0505 29.1875 33.8885C29.1875 35.7266 30.6775 37.2166 32.5156 37.2166Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M32.9869 33.266L23.4175 18.7035C23.1912 18.3592 22.7287 18.2635 22.3844 18.4897L22.3833 18.4904C22.039 18.7167 21.9433 19.1792 22.1696 19.5235L31.739 34.0861C31.9653 34.4304 32.4278 34.5261 32.7721 34.2998L32.7732 34.2991C33.1175 34.0729 33.2132 33.6103 32.9869 33.266Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M23.1368 12.042L27.7416 19.1175L26.0781 23.9513L26.0769 23.9538H26.0744L20.9815 23.5158L16.3779 16.4402L21.7262 17.2676L23.1368 12.042Z'
        fill={spotIllustration.secondary.fill}
      />
    </Svg>
  )
}
